import React from 'react';
import Field, { fieldTypes } from '../../../../../../shared/ui/Field';
import { fieldNames } from '../../../config';
import { validateFileSizeForForm } from '../../../../../../../../helpers/validateFile';
import { maxFileSize } from '../../../../../../../../constants/maxFileSize';

const UploadFilesField = ({ form, initialValue }) => {
  const handleChange = (info) => {
    if (info.fileList?.length) {
      const hasBigFile = info.fileList.some((file) => file.size > maxFileSize);

      if (hasBigFile) {
        const newFileList = info.fileList.map((file) => {
          if (file.size > maxFileSize) {
            file.status = 'error';
          }
          return file;
        });
        form.setFieldsValue({ [fieldNames.files]: newFileList });
      }
    }
  };

  return (
    <Field
      fieldType={fieldTypes.uploadDragger}
      form={form}
      name={fieldNames.files}
      label="Вложения"
      decoratorOptions={{
        initialValue: initialValue || [],
        rules: [
          {
            validator: validateFileSizeForForm,
          },
        ],
      }}
      fieldProps={{
        multiple: true,
        onChange: handleChange,
      }}
    />
  );
};

export default UploadFilesField;
